import { render, staticRenderFns } from "./toDevelop.vue?vue&type=template&id=30f47fa6&"
import script from "./toDevelop.vue?vue&type=script&lang=js&"
export * from "./toDevelop.vue?vue&type=script&lang=js&"
import style0 from "./toDevelop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports